export default __webpack_public_path__ + "static/media/nft.8a780410.gif";